import { render, staticRenderFns } from "./Start2.vue?vue&type=template&id=3a9dbdf8&"
import script from "./Start2.vue?vue&type=script&lang=js&"
export * from "./Start2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports